declare let BUILD_VERSION: string; // Defined by webpack at build/compile time using DefinePlugin
export const buildVersion = BUILD_VERSION;

declare let ASSET_ROOT: string;
export const assetRoot = ASSET_ROOT;

declare let USER_EVENTS: boolean;
export const userEvents = USER_EVENTS;
